const { isValid } = require('./isValid')
const { getParts } = require('./getParts')

/**
 * Két szemver összevetése, hogy az elsőnek megadott nagyobb-e, mint a másik.
 * @param {any} semver1 - Az első paraméter, ehhez viszonyítjuk a másikat.
 * @param {any} semver2 - A második paraméter.
 * @returns {boolean} Az első nagyobb, mint a második?
 */
module.exports.gt = function gt (semver1, semver2) {
  if (!isValid(semver1) && !isValid(semver2)) {
    return false
  }

  const parts1 = getParts(semver1)
  const parts2 = getParts(semver2)

  if (parts1.major > parts2.major) {
    return true
  }

  if (parts1.major < parts2.major) {
    return false
  }

  if (parts1.minor > parts2.minor) {
    return true
  }

  if (parts1.minor < parts2.minor) {
    return false
  }

  if (parts1.patch > parts2.patch) {
    return true
  }

  return false
}
